export default __webpack_public_path__ + "static/media/options.ad981d57.svg";